import React, { useState, useEffect } from "react";
import "./FilterSideDrawer.css";

export default function FilterSideDrawer({ 
  isOpen, 
  onClose, 
  onApply, 
  defaultNiin = [] 
}) {
  const [niinExpanded, setNiinExpanded] = useState(false);
  const [niinInput, setNiinInput] = useState("");
  const [niinList, setNiinList] = useState([]);

  // Sync default values when drawer opens
  useEffect(() => {
    if (isOpen) {
      setNiinList(defaultNiin);
      console.log("DefaultNiin:", defaultNiin);
      console.log("NiinList state:", niinList);
    }
  }, [isOpen, defaultNiin]);

  // Handle NIIN form submission
  const handleNiinSubmit = (e) => {
    e.preventDefault();
    if (niinInput.trim() === "") return;
    setNiinList((prev) => [...prev, niinInput.trim()]);
    setNiinInput("");
  };

  // Remove NIIN from list
  const handleRemoveNiin = (item) => {
    setNiinList((prev) => prev.filter((n) => n !== item));
  };

  // Apply filters
  const handleApply = () => {
    onApply({ niin: niinList });
    onClose();
  };

  // Clear all
  const handleClearAll = () => {
    setNiinList([]);
    onApply({ niin: [] });
    onClose();
  };

  return (
    <>
      {isOpen && <div className="drawer-overlay" onClick={onClose}></div>}

      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <h2>Filters</h2>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* NIIN Section */}
        <div className="filter-section">
          <button
            className="filter-toggle"
            onClick={() => setNiinExpanded(!niinExpanded)}
          >
            <span>NIIN</span>
            <span className={`carrot ${niinExpanded ? "up" : "down"}`}>⌃</span>
          </button>

          {niinExpanded && (
            <div className="filter-content">
              <form onSubmit={handleNiinSubmit}>
                <label>Type any part of the NIIN</label>
                <input
                  type="text"
                  value={niinInput}
                  onChange={(e) => setNiinInput(e.target.value)}
                  placeholder="Ex. 44 or 102032"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleNiinSubmit(e);
                    }
                  }}
                />
              </form>

              <div className="niin-list">
                {niinList.map((item, idx) => (
                  <button
                    key={idx}
                    className="niin-item"
                    onClick={() => handleRemoveNiin(item)}
                  >
                    ✕ {item}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="drawer-footer">
          <button className="clear-btn" onClick={handleClearAll}>
            Clear all
          </button>
          <button className="apply-btn" onClick={handleApply}>
            Apply Filters
          </button>
        </div>
      </div>
    </>
  );
}